import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hire-skeleton-loaders',
  imports: [],
  templateUrl: './hire-skeleton-loaders.component.html',
  styleUrl: './hire-skeleton-loaders.component.scss',
  standalone:true
})
export class HireSkeletonLoadersComponent {

  @Input() candidateListLoader: boolean = false;
  @Input() showExplanationLoader: boolean = false;
  @Input() showJDFitLoader: boolean = false;
  @Input() showLongSummaryLoader: boolean = false;
  rows = Array(3);
  chips = Array(7);
  footerCards = Array(5);

  // Varied widths so rows don't look identical
  chipWidths      = [72, 90, 65, 100, 80, 70, 88];
  rowTitleWidths  = [260, 200, 230];
  rowMeta1Widths  = [90, 90, 90];
  rowMeta2Widths  = [220, 220, 220];
  rowMeta3Widths  = [160,  160, 160];
  rowMeta4Widths  = [70,  70, 70];
  footerWidths    = [120, 88, 76, 92, 100];
}
